import { Record } from "./.fable/fable-library.3.1.4/Types.js";
import { record_type, string_type } from "./.fable/fable-library.3.1.4/Reflection.js";

export class FableModule extends Record {
    constructor(Platzhalter, ModuleName, ServiceName) {
        super();
        this.Platzhalter = Platzhalter;
        this.ModuleName = ModuleName;
        this.ServiceName = ServiceName;
    }
}

export function FableModule$reflection() {
    return record_type("TagungsProgramm.Global.FableModule", [], FableModule, () => [["Platzhalter", string_type], ["ModuleName", string_type], ["ServiceName", string_type]]);
}

export const fableModule = new FableModule("TagungsProgramm", "TagungsProgramm", "Service");

